import axios from 'axios';

class JobAlerts {
    constructor() {
        this.form = document.getElementById('job-alert-form');
        if (!this.form) return;

        this.message = document.querySelector('.job-alert__message');

        this.form.addEventListener('submit', (e) => {
            this.registerAlert(e);
        });
    }

    async registerAlert(e) {
        e.preventDefault();
        const { grecaptcha, GLOBALS } = window;

        grecaptcha.ready(async () => {
            const token = await grecaptcha.execute(GLOBALS.RECAPTCHA_SITE_KEY, { action: 'submit' });
            document.querySelector('#job-alert-form #grecaptcha').value = token;

            const form = new FormData(this.form);
            // eslint-disable-next-line
            const { data } = await axios.post("/wp-json/diabolo-poivre/job-alerts", form);
            if (data.type === 'error') {
                this.message.classList.add('job-alert__message--error');
            } else {
                this.message.classList.remove('job-alert__message--error');
            }

            this.message.innerText = data.message;
        });
    }
}

export default JobAlerts;
